<div class="ei-input-field">
    @if (showLabel || alwaysShowLabel) {
        <label
            class="ei-input-field__label"
            [class.ei-input-field__label--has-value]="hasValue(value)"
        >
            {{ config.label }}
            @if (config.required) {
                <span class="ei-input-field__required">*</span>
            }
        </label>
    }

    <div class="ei-input-field__control">
        @switch (config.type) {
            @case (fieldType.Text) {
                @if (config.required) {
                    <div class="ei-input-field__input-wrapper">
                        <input
                            class="ei-input-field__input"
                            [placeholder]="placeholderText"
                            [value]="value ?? ''"
                            type="text"
                            [attr.maxlength]="config.maxLength ?? null"
                            (input)="onInputChange($event)"
                            (keydown)="onTextFilterKeyDown($event)"
                            (paste)="onTextFilterPaste($event)"
                            (blur)="blur.emit()"
                        />
                        @if (!hasValue(value) && placeholderText) {
                            <span class="ei-input-field__placeholder-text">{{
                                placeholderText
                            }}</span>
                        }
                    </div>
                } @else {
                    <input
                        class="ei-input-field__input"
                        [placeholder]="placeholderText"
                        [value]="value ?? ''"
                        type="text"
                        [attr.maxlength]="config.maxLength ?? null"
                        (input)="onInputChange($event)"
                        (keydown)="onTextFilterKeyDown($event)"
                        (paste)="onTextFilterPaste($event)"
                        (blur)="blur.emit()"
                    />
                }
            }

            @case (fieldType.Email) {
                @if (config.required) {
                    <div class="ei-input-field__input-wrapper">
                        <input
                            class="ei-input-field__input"
                            [placeholder]="placeholderText"
                            [value]="value ?? ''"
                            type="email"
                            [attr.maxlength]="config.maxLength ?? null"
                            (input)="onInputChange($event)"
                            (keydown)="onEmailKeyDown($event)"
                            (paste)="onEmailPaste($event)"
                            (blur)="blur.emit()"
                        />
                        @if (!hasValue(value) && placeholderText) {
                            <span class="ei-input-field__placeholder-text">{{
                                placeholderText
                            }}</span>
                        }
                    </div>
                } @else {
                    <input
                        class="ei-input-field__input"
                        [placeholder]="placeholderText"
                        [value]="value ?? ''"
                        type="email"
                        [attr.maxlength]="config.maxLength ?? null"
                        (input)="onInputChange($event)"
                        (keydown)="onEmailKeyDown($event)"
                        (paste)="onEmailPaste($event)"
                        (blur)="blur.emit()"
                    />
                }
            }

            @case (fieldType.Number) {
                @if (config.required) {
                    <div class="ei-input-field__input-wrapper">
                        <input
                            class="ei-input-field__input"
                            [placeholder]="placeholderText"
                            [value]="value ?? ''"
                            [type]="config.restrictToPositiveIntegerDigits ? 'text' : 'number'"
                            [attr.inputmode]="
                                config.restrictToPositiveIntegerDigits ? 'numeric' : null
                            "
                            [attr.maxlength]="
                                config.restrictToPositiveIntegerDigits && config.maxDigits != null
                                    ? config.maxDigits
                                    : null
                            "
                            (input)="onInputChange($event)"
                            (keydown)="onPositiveIntegerDigitsKeyDown($event)"
                            (paste)="onPositiveIntegerDigitsPaste($event)"
                            (blur)="blur.emit()"
                        />
                        @if (!hasValue(value) && placeholderText) {
                            <span class="ei-input-field__placeholder-text">{{
                                placeholderText
                            }}</span>
                        }
                    </div>
                } @else {
                    <input
                        class="ei-input-field__input"
                        [placeholder]="placeholderText"
                        [value]="value ?? ''"
                        [type]="config.restrictToPositiveIntegerDigits ? 'text' : 'number'"
                        [attr.inputmode]="config.restrictToPositiveIntegerDigits ? 'numeric' : null"
                        [attr.maxlength]="
                            config.restrictToPositiveIntegerDigits && config.maxDigits != null
                                ? config.maxDigits
                                : null
                        "
                        (input)="onInputChange($event)"
                        (keydown)="onPositiveIntegerDigitsKeyDown($event)"
                        (paste)="onPositiveIntegerDigitsPaste($event)"
                        (blur)="blur.emit()"
                    />
                }
            }

            @case (fieldType.Phone) {
                <div
                    class="ei-input-field__phone"
                    [class.ei-input-field__phone--has-value]="
                        hasValue(value) || countryValue || countryCodePrefix
                    "
                >
                    <div
                        class="ei-input-field__country"
                        [class.ei-input-field__country--prefix-only]="countryCodePrefix"
                    >
                        @if (countryCodePrefix) {
                            <span class="ei-input-field__country-prefix">{{
                                countryCodePrefix
                            }}</span>
                        } @else {
                            <button
                                type="button"
                                class="ei-input-field__country-trigger"
                                (click)="toggleCountryDropdown($event)"
                                [attr.aria-expanded]="isCountryDropdownOpen()"
                            >
                                <span class="ei-input-field__country-trigger-text">{{
                                    selectedCountryLabel
                                }}</span>
                                <span
                                    class="ei-input-field__country-chevron"
                                    aria-hidden="true"
                                ></span>
                            </button>

                            <div
                                class="ei-input-field__country-panel"
                                [class.ei-input-field__country-panel--open]="
                                    isCountryDropdownOpen()
                                "
                                role="listbox"
                            >
                                @for (
                                    option of countryOptions;
                                    track trackByOption($index, option)
                                ) {
                                    <button
                                        type="button"
                                        class="ei-input-field__country-option"
                                        [class.ei-input-field__country-option--selected]="
                                            option.value === countryValue
                                        "
                                        (click)="selectCountry(option.value)"
                                    >
                                        <span class="ei-input-field__country-option-label">{{
                                            option.label
                                        }}</span>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                    @if (config.required) {
                        <div class="ei-input-field__input-wrapper">
                            <input
                                class="ei-input-field__input"
                                [placeholder]="placeholderText"
                                [value]="value ?? ''"
                                type="tel"
                                (input)="onInputChange($event)"
                                (keydown)="onPhoneKeyDown($event)"
                                (paste)="onPhonePaste($event)"
                                (blur)="blur.emit()"
                            />
                            @if (
                                !hasValue(value) &&
                                !countryValue &&
                                !countryCodePrefix &&
                                placeholderText
                            ) {
                                <span class="ei-input-field__placeholder-text">{{
                                    placeholderText
                                }}</span>
                            }
                        </div>
                    } @else {
                        <input
                            class="ei-input-field__input"
                            [placeholder]="placeholderText"
                            [value]="value ?? ''"
                            type="tel"
                            (input)="onInputChange($event)"
                            (keydown)="onPhoneKeyDown($event)"
                            (paste)="onPhonePaste($event)"
                            (blur)="blur.emit()"
                        />
                    }
                </div>
            }

            @case (fieldType.Date) {
                <div class="ei-input-field__date">
                    <div
                        class="ei-input-field__input-wrapper"
                        [class.ei-input-field__input-wrapper--date-empty]="!hasValue(value)"
                        [class.ei-input-field__input-wrapper--date-custom-display]="
                            hasValue(value) && dateDisplayText
                        "
                    >
                        <label class="ei-input-field__date-label" [attr.title]="null">
                            <span
                                class="ei-input-field__date-display"
                                [class.ei-input-field__date-display--empty]="!hasValue(value)"
                            >
                                @if (hasValue(value)) {
                                    {{ formatDateDisplayDdMmmYyyy(value) }}
                                } @else {
                                    {{ config.placeholder ?? 'DD-MMM-YYYY' }}
                                }
                            </span>
                            <input
                                class="ei-input-field__input ei-input-field__input--date"
                                [class.ei-input-field__input--date-custom]="
                                    hasValue(value) && dateDisplayText
                                "
                                type="date"
                                [attr.title]="null"
                                [value]="formatDateValue(value)"
                                [min]="formatDateValue(config.minDate ?? null)"
                                [max]="formatDateValue(config.maxDate ?? null)"
                                (change)="onDateChange($event)"
                                (blur)="blur.emit()"
                            />
                            @if (hasValue(value) && dateDisplayText) {
                                <span class="ei-input-field__date-display-text">{{
                                    dateDisplayText
                                }}</span>
                            }
                            <span class="ei-input-field__date-icon" aria-hidden="true">
                                <svg
                                    width="17"
                                    height="16"
                                    viewBox="0 0 17 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.7056 4.50671L12.459 13.5267C12.299 14.2001 11.699 14.6667 11.0056 14.6667H2.24562C1.23895 14.6667 0.518961 13.68 0.818961 12.7133L3.62562 3.70007C3.81896 3.07341 4.39896 2.64001 5.0523 2.64001H13.2523C13.8856 2.64001 14.4123 3.02668 14.6323 3.56002C14.759 3.84668 14.7856 4.17338 14.7056 4.50671Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                    />
                                    <path
                                        d="M10.7524 14.6667H13.9391C14.7991 14.6667 15.4724 13.94 15.4124 13.08L14.7524 4"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M6.53906 4.25338L7.2324 1.37341"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M11.0056 4.26001L11.6323 1.3667"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M5.21899 8H10.5523"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M4.55249 10.6666H9.88582"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                        </label>
                    </div>
                </div>
            }

            @case (fieldType.Select) {
                <!-- Custom dropdown with create new option -->
                @if (config.allowCreateNew) {
                    <div class="ei-input-field__custom-select">
                        <button
                            type="button"
                            class="ei-input-field__select-button"
                            (click)="onDropdownToggle($event)"
                        >
                            <span class="ei-input-field__select-value">{{
                                displayValue || config.placeholder || ''
                            }}</span>
                            <span
                                class="ei-input-field__select-arrow"
                                [class.ei-input-field__select-arrow--open]="isDropdownOpen()"
                                ><app-svg-icon name="expand_more" size="lg"
                            /></span>
                        </button>
                        <div
                            class="ei-input-field__dropdown"
                            [class.ei-input-field__dropdown--open]="isDropdownOpen()"
                        >
                            <!-- Options list -->
                            @if (availableOptions().length > 0) {
                                <ul class="ei-input-field__options-list">
                                    @for (
                                        option of availableOptions();
                                        track trackByOption($index, option)
                                    ) {
                                        <li
                                            class="ei-input-field__option-item"
                                            (click)="onOptionSelect(option)"
                                        >
                                            {{ option.label }}
                                        </li>
                                    }
                                </ul>
                            }
                            <!-- Create new section -->
                            @if (config.allowCreateNew) {
                                <div class="ei-input-field__create-section">
                                    <div class="ei-input-field__create-title">Create New Title</div>
                                    @if (newOptionInput()) {
                                        <div class="ei-input-field__create-suggestion">
                                            {{ newOptionInput() }} in Title
                                        </div>
                                    }
                                    <div class="ei-input-field__create-form">
                                        <input
                                            class="ei-input-field__create-input"
                                            type="text"
                                            [value]="newOptionInput()"
                                            (input)="onNewOptionInput($event)"
                                            placeholder="Enter new title"
                                        />
                                        <button
                                            type="button"
                                            class="ei-input-field__create-button"
                                            (click)="onCreateNew()"
                                        >
                                            Create
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
                <!-- Native select for non-create-new dropdowns -->
                @if (!config.allowCreateNew) {
                    <select
                        class="ei-input-field__select"
                        [value]="value ?? ''"
                        (change)="onSelectChange($event)"
                    >
                        @for (option of config.options || []; track trackByOption($index, option)) {
                            <option [value]="option.value">
                                {{ option.label }}
                            </option>
                        }
                    </select>
                }
            }
        }
    </div>

    @if (invalidTextMessage()) {
        <div class="ei-input-field__inline-error">{{ invalidTextMessage() }}</div>
    }
</div>
